<template>
  <v-container class="container mt-4 px-10" fluid>
    <base-back-button v-if="!$route.meta.hideBackButton" class="mb-2" />
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: 'RouteWrapper',
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1920px;
}
</style>
